module.exports = __webpack_public_path__ + "img/53ne.e9309e2a.svg";